import { render, staticRenderFns } from "./Parcela.vue?vue&type=template&id=298288c7&scoped=true"
import script from "./Parcela.vue?vue&type=script&lang=js"
export * from "./Parcela.vue?vue&type=script&lang=js"
import style0 from "./Parcela.vue?vue&type=style&index=0&id=298288c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298288c7",
  null
  
)

export default component.exports